import { z } from "zod";

import {
  deliveryDateSchema,
  trialDeliveryFeeSchema,
  ongoingDeliveryFeeSchema,
} from "./primitives";

export const deliveryDataSchema = z.object({
  deliveryDate: deliveryDateSchema,
  trialDeliveryFee: trialDeliveryFeeSchema,
  ongoingDeliveryFee: ongoingDeliveryFeeSchema,
});

export type TDeliveryData = z.infer<typeof deliveryDataSchema>;
